import React from 'react';
import styled from 'styled-components';
import { ButtonSimple } from '../form/button/ButtonSimple';

const Root = styled.div`
  background: #fff;
  padding: 1rem 1.5rem;
`;

const Message = styled.div`
  display: block;
  padding-bottom: 1rem;
`;

const ButtonPanel = styled.div`
  text-align: right;
`;

const ButtonYes = styled(ButtonSimple)`
  margin-right: 0.5rem;
`;

export const MessageYesNo = (props: { text: string; onYes: () => void; onNo: () => void }) => {
  const { text, onYes, onNo } = props;

  return (
    <Root>
      <Message>{text}</Message>
      <ButtonPanel>
        <ButtonYes onClick={onYes}>Yes</ButtonYes>
        <ButtonSimple onClick={onNo}>No</ButtonSimple>
      </ButtonPanel>
    </Root>
  );
};
